<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      :preloader="preloader"
      @close-modal="closeModal"
    >
      <template slot="header">
        <h5>{{modalTitle}}</h5>
      </template>
      <template slot="body">
        <el-form v-if="active === 1">
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="addurl">
            <div class="form-group row align-items-center">
              <div class="col-sm-4 mb-0">
                <label>
                  {{ $t("users") }}
                </label>
              </div>
              <div class="col-sm-8">
                <app-input
                  id="inputs_user_id"
                
                  type="search-select"
                  v-model="inputs.user_id"
                  :isAnimatedDropdown="true"
                  :required="true"
                  :placeholder="$t('select_user')"
                  :list="internal_users"
                />
                <p class="font-italic text-muted">
                  {{ $t("shortcut_user_create") }} <span><a href="#" @click.prevent="addUser()">{{$t("add_user")}}</a></span>
                </p>
              </div>
            </div>
            <div class="form-group">
              <label>Assigned Users</label>
              <div v-for="user in users">
                {{user.value}}
                <button class="btn btn-sm text-danger" @click.prevent="deleteAssignedUser(user.id)">x</button>
              </div>
            </div>
          </form>
        </el-form>
        <el-form v-if="active === 2">
          <shortcut-user-create :back="backTaskCreate"></shortcut-user-create> 
        </el-form>
      </template>
      <template slot="footer" v-if="active === 1">
        <button class="btn btn-secondary mr-2" @click.prevent="closeModal">{{$t('close')}}</button>
        <button class="btn btn-primary" @click.prevent="submit">{{$t('save')}}</button>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../../app/Mixins/ModalMixin";
import { axiosPost, axiosGet } from "../../../../../../Helpers/AxiosHelper";
import { ROLES, INTERNAL_USERS, SITE_USER_ASSIGNED, GET_SITE_USER_ASSIGNED_LIST, DELETE_SITE_ASSIGNED_USER } from "../../../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    id: Number,
  },
  data() {
    return {
      active: 1,
      internal_users: [],
      addurl:SITE_USER_ASSIGNED,
      preloader: false,
      users: null,
      inputs: {},
      roleLists: [],
      modalId: "demo-assign-user-Modal",
      modalTitle: this.$t("assign_user"),
    }
  },
  methods: {
    addUser() {
      this.modalTitle = this.$t("add_user");
      this.active = 2;
    },
    backTaskCreate(value) {
      this.getInternalUsers();
      this.active = value;
    },
    submit() {
      this.inputs.site_id = this.id;
        let formData = new FormData();
        Object.keys(this.inputs).forEach((key) => {
          formData.append(key,this.inputs[key]);
        });
      this.save(formData);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
    },
    getInternalUsers() {
      
      axiosGet(INTERNAL_USERS)
        .then((res) => {
          this.internal_users = res.data;
        })
        .catch((error) => {
          
        });
    },
    getUsers() {
      axiosGet(GET_SITE_USER_ASSIGNED_LIST + "/" + this.id)
        .then((res) => {
          this.users = res.data;
        })
        .catch((error) => {
          
        });
    },
    deleteAssignedUser(user_id) {
      axiosGet(DELETE_SITE_ASSIGNED_USER + "/" + this.id + "?user_id=" + user_id)
        .then((res) => {
          this.getUsers();
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getInternalUsers();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
    this.getUsers();
  },
  computed: {
     userRole() {
      return this.$store.state.user.loggedInUser;
    },
  }
};
</script>
